// src/components/LanguageToggle.jsx
import React from 'react';
import { motion } from 'framer-motion';
import './LanguageToggle.css';

const LanguageToggle = ({ language, setLanguage }) => {
  return (
    <motion.div 
      className="language-toggle"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.5 }}
    >
      <button
        className={`lang-btn ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
      >
        EN
      </button>
      <motion.div 
        className="toggle-slider"
        animate={{ x: language === 'en' ? 0 : '100%' }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      />
      <button
        className={`lang-btn ${language === 'sr' ? 'active' : ''}`}
        onClick={() => setLanguage('sr')}
      >
        SR
      </button>
    </motion.div>
  );
};

export default LanguageToggle;
